/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { History } from "history";
import React, { Component, FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import config from "../../config";
import { AppState } from "../../redux";
import { fetchOAuthConfigActions, fetchToken } from "../../redux/session/actions";

interface OAuthWrapperProps extends RouteComponentProps {}

export class OAuthWrapper extends Component<OAuthWrapperProps> {
  render() {
    const params = new URLSearchParams(this.props.location.search);
    const code = params.get("code")!;

    return <OAuth code={code} history={this.props.history} />;
  }
}

interface OAuthProps {
  code: string;
  history: History<any>;
}

const OAuth: FC<OAuthProps> = ({ code, history }) => {
  const oauthConfig = useSelector((state: AppState) => state.session.oauth);
  const dispatch = useDispatch();

  useEffect(
    function obtainToken() {
      if (oauthConfig === null) {
        dispatch(fetchOAuthConfigActions.request(config.dfdmHost));
        return;
      }

      dispatch(fetchToken(code, oauthConfig, history));
    },
    [oauthConfig, dispatch, history, code]
  );

  return <div />;
};

export default OAuthWrapper;
